import { render, staticRenderFns } from "./Documento.vue?vue&type=template&id=73f8d8e9&"
import script from "./Documento.vue?vue&type=script&lang=js&"
export * from "./Documento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports